//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapGetters, mapActions } from 'vuex';
import { faDownToBracket, faCheck } from '@fortawesome/pro-solid-svg-icons';
import notificationService from '@motionelements/core/src/services/notification.service.js';
import product2025Mixin from '@motionelements/product2025/src/mixins/product-2025.mixin.js';
import showSignUpModalMixin from '@motionelements/product2025/src/mixins/show-sign-up-modal.mixin.js';

export default {
  name: 'AddToCartButton',
  components: {
    ButtonLadda: () => import('@motionelements/core/src/components/ui/BaseButtonLadda.vue'),
  },
  mixins: [showSignUpModalMixin, product2025Mixin],
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      faDownToBracket,
      faCheck,
      loading: false,
    };
  },
  computed: {
    ...mapState({
      product: state => state.product.current,
    }),
    ...mapGetters({
      masterVariant: 'product/masterVariant',
    }),
    buttonText() {
      switch (true) {
        case this.loading:
          return this.$t('term.adding');
        case this.isAdded(this.product.id):
          return this.$t('term.added_to_cart');
        default:
          return this.$t('cta.add_to_cart');
      }
    },
  },
  methods: {
    ...mapActions({
      ADD_ELEMENTS_TO_CART: 'cart/ADD_ELEMENTS_TO_CART',
    }),
    addProductToCart() {
      return this.loggedInCheck()
        .then((loggedIn) => {
          if (loggedIn) {
            this.loading = true;
            return this.ADD_ELEMENTS_TO_CART({ skus: [this.masterVariant.id] })
              .then((response) => {
                console.log('added to cart', response);
                if (response.status === 201) {
                  notificationService.alert({
                    level: 'success',
                    title: this.$i18n.t('favorites.product_added_to_your_cart'),
                  });
                  this.$bus.$emit('product-added-to-cart', {
                    products: response.data.data,
                  });
                }
              })
              .finally(() => {
                this.loading = false;
              });
          }
        });
    },
  },
};
